import type { CreateReagentRecipeInput, ReagentRecipeRow } from '#shared/types';

/** Whether a recipe line is drawn once per sample or once per analyte. */
export type RecipeLevel = 'test' | 'parameter';

/** The form's starting values: the saved recipe when editing, blanks when adding. */
export function initialRecipeValues(record?: ReagentRecipeRow): CreateReagentRecipeInput {
  if (!record) {
    return {
      item_id: 0,
      test_id: null,
      parameter_id: null,
      quantity_base: 1,
      note: '',
      is_active: true,
    };
  }
  return {
    item_id: record.item_id,
    test_id: record.test_id,
    parameter_id: record.parameter_id,
    quantity_base: record.quantity_base,
    note: record.note ?? '',
    is_active: record.is_active,
  };
}

/** A saved sample-level recipe opens at sample level; anything else at analyte level. */
export function initialRecipeLevel(record?: ReagentRecipeRow): RecipeLevel {
  return record?.parameter_id === null ? 'test' : 'parameter';
}

/**
 * Exactly one target, mirroring the CHECK constraint. Switching level clears
 * the other side rather than leaving both set, which the server would refuse.
 */
export function clearOtherTarget(level: RecipeLevel): Partial<CreateReagentRecipeInput> {
  return level === 'test' ? { parameter_id: null } : { test_id: null };
}
